module.exports = __webpack_public_path__ + "static/img/manual_ja_9.c4e9c04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_9.png
// module id = whg0
// module chunks = 4